module.exports = __webpack_public_path__ + "static/media/banner1.4a76a284.jpg";